import Tab from 'bootstrap/js/dist/tab';
import { Fancyapps } from './../../Libraries/Fancyapps';
import "./_SizeChart.scss";

export class SizeChart
{
	private Chart: HTMLElement;
	private ChartLink: HTMLLinkElement;

	constructor()
	{
		this.Initialize();
		this.ConfigureSizeChartLink();

		if (this.Chart !== null)
		{
			this.ConfigureUnitSelect(this.Chart);
		}
	}

	private Initialize = (): void =>
	{
		this.Chart = document.querySelector(".sizeChart") as HTMLElement;
	};

	private ConfigureSizeChartClone = (slide): void =>
	{
		const content = slide.$content as HTMLElement;

		if (typeof content !== null)
		{
			const idElements = content.querySelectorAll("*[id]");
			const buttons = content.querySelectorAll(".nav-link");
			const panes = content.querySelectorAll(".tab-pane");
			content.classList.add("sizeChart--clone");

			idElements.forEach((element: HTMLElement) =>
			{
				element.id = element.id + "--clone";
			});

			panes.forEach((pane: HTMLElement) =>
			{
				pane.setAttribute("aria-labelledby", `${pane.getAttribute("aria-labelledby")}--clone`);
			});

			buttons.forEach((button: HTMLElement) =>
			{
				button.setAttribute("aria-controls", `${button.getAttribute("aria-controls")}--clone`);
				button.setAttribute("data-bs-target", `${button.getAttribute("data-bs-target")}--clone`);
				const tabTrigger = new Tab(button);

				button.addEventListener("click", event =>
				{
					event.preventDefault();
					const target = event.currentTarget as HTMLElement;
					const nonCloneButton = document.querySelector(`#${target.id.replace("--clone", "")}`);

					tabTrigger.show();
					nonCloneButton.dispatchEvent(new Event("click", { cancelable: true }));
				});
			});

			this.ConfigureUnitSelect(content);
		}
	};

	private ConfigureSizeChartLink = (): void =>
	{
		this.ChartLink = document.querySelector("#hlViewSizes");

		if (this.ChartLink !== null)
		{
			this.ChartLink.addEventListener("click", this.DisplayInModal);
		}
	};

	private ConfigureUnitSelect = (chart: HTMLElement): void =>
	{
		if (chart !== null)
		{
			const unitButtons = chart.querySelectorAll(".sizeChart__unit .btn");

			if (unitButtons.length > 0)
			{
				unitButtons.forEach((button) =>
				{
					button.addEventListener("click", this.SetUnit);
				});
			}
		}
	};

	private DisplayInModal = async (e: Event): Promise<void> =>
	{
		e.preventDefault();
		const fancyapps = await Fancyapps.Import();
		const fancybox = fancyapps.Fancybox;
		const sizeChartModal = new fancybox(
			[
				{
					src: "#prdSizes",
					type: "clone"
				}
			]
		);

		sizeChartModal.on("done", (fancybox, slide) =>
		{
			this.ConfigureSizeChartClone(slide);
		});
	};

	private SetUnit = (e: Event): void =>
	{
		e.preventDefault();

		const target = e.currentTarget as HTMLElement;
		const charts = document.querySelectorAll(".sizeChart");

		if (charts.length)
		{
			charts.forEach((chart: HTMLElement) =>
			{
				chart.querySelector(".sizeChart__unit .active").classList.remove("active");
				chart.classList.remove("sizeChart--met", "sizeChart--std");

				if (target.classList.contains("std"))
				{
					chart.classList.add("sizeChart--std");
					chart.querySelector(".sizeChart__unit .std").classList.add("active");
				}
				else
				{
					chart.classList.add("sizeChart--met");
					chart.querySelector(".sizeChart__unit .met").classList.add("active");
				}
			});
		}
	};
}